import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for UnoShellStore, for use in the registry */ export const UnoShellStoreActionTypes = [
    ActionType.UpdateChildViewStatusAction
];
